<template>
  <div
    id="cart"
    class="container-fluid">
    <div class="row border-bottom border-muted py-3">
      <div class="
        col
        d-flex
        flex-column
        flex-lg-row
        align-items-center
      ">
        <h3 class="mb-3 m-lg-0">
          Cart Total: {{registrationSession.amount_to_charge | currency}}
        </h3>

        <div class="flex-fill d-xs-none d-lg-block"></div>

        <div class="d-flex justify-content-between">
          <b-button
            class="mr-3"
            variant="primary"
            type="button"
            @click="goToEvent()">
            Add {{!cartEmpty ? 'Another' : ''}} Registrant
          </b-button>

          <b-button
            variant="success"
            type="button"
            :disabled="cartEmpty || failedRegistration || submitting"
            @click="next">
            <span v-if="isZeroDollarCart && !cartEmpty">Register Without Charge</span>
            <span v-else>Checkout</span>
          </b-button>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <!-- Cart Items -->
      <CartSummary
        class="col"
        @remove-registration="removeRegistration"
      />
      <!-- / Cart Items -->
    </div>
  </div>
</template>

<script>
import AppMixin from '../services/mixin.app';
import CartSummary from '../components/CartSummary.vue';

export default {
  name: 'cart',
  mixins: [AppMixin],
  data() {
    return {
      submitting: false,
    };
  },
  components: {
    CartSummary,
  },
  methods: {
    next() {
      this.submitting = true;
      this.showGlobalLoader('Processing...');

      this.checkCostScenario(this.goToCheckout)
        .finally(() => {
          this.submitting = false;
          this.hideGlobalLoader();
        });
    },
  },
};
</script>

<style lang="scss"></style>
